import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import DistVafCircularProgress from "./common/distVafCircularProgress";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import $ from 'jquery'
import { URL_API } from '../config/urls'
import {formatarIdentificacao} from './util';
import fetchWithToken from '../config/UseFetchWithToken';
import { ApprovalOutlined, CancelOutlined, PictureAsPdfOutlined } from '@mui/icons-material';

export default function AtualizacaoAprovar() {

    const nav = useNavigate();
    const [solicitacoes, setSolicitacoes] = useState([]);
    const [loader, setLoader]  = useState(true);
    const [justificativa, setJustificativa] = useState("");
    const [solicitacaoSelecionado, setSolicitacaoSelecionado] = useState(0);
    const [mostrarModalJustificativa, setMostrarModalJustificativa] = useState(false);

    useEffect(() => {

        setLoader(true)

        let token_keycloack = sessionStorage.getItem('token_keycloack');
		const requestAuthorization = {
			headers: { "Authorization": `Bearer ${token_keycloack}` }
		}

        let url = `${URL_API}/api/v1/public/atualizaPrefeitura/obterSolicitacoesNaoAprovadas`
        fetchWithToken(url, requestAuthorization)
			.then(res => res.json())
			.then(res => {
			    if(res.length > 0){
                    setSolicitacoes(res);
                }
                else {
                    alert("Não possui solicitações aguardando aprovação.")
                }
                carregarTabela();
                setLoader(false);
            })
            .catch(_err => {
				alert("Erro interno na aplicação - " + _err)
				console.error("Erro interno na aplicação - " + _err)
                setLoader(false);
			});
    }, [])

    function getUsuarioLogado() {
        const usuarioLogado = sessionStorage.getItem('usuarioLogado');
        if (usuarioLogado != null) {
            return usuarioLogado;
        }
        else{
            alert("Sessão expirada. Favor logar novamente.")
            window.location.href = '/login';
        }
        return "";
    }

    function aprovarSolicitacao (sqSolicitacao)  {

        setLoader(true)

        let token_keycloack = sessionStorage.getItem('token_keycloack');

        let url = `${URL_API}/api/v1/public/atualizaPrefeitura/aprovarSolicitacao`
        const opcoes = {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', "Authorization": `Bearer ${token_keycloack}` },
            body: 
            "sqSolicitacao="+ sqSolicitacao +
            "&usuarioLogado="+ getUsuarioLogado()
        };
        fetchWithToken(url,opcoes)
        .then(res => res.json())
        .then(res => {
            const retorno = JSON.parse(res);
			//const retornoTratado = JSON.parse(retorno[0]);
			if(retorno[0].status === 'OK'){
                setSolicitacoes(res);
                window.location.reload();
                setLoader(false)
                alert("Solicitação foi aprovada.")
            }
            else {
             alert("Erro interno na aplicação - " + res.trace)
                console.error("Erro interno na aplicação - " + res.trace)
            }
            setLoader(false)
        })
        .catch(_err => {
            alert("Erro interno na aplicação - " + _err)
            console.error("Erro interno na aplicação - " + _err)
            setLoader(false)
        });
    }

    function reprovarSolicitacao (sqSolicitacao) {

        setLoader(true)
        let url = `${URL_API}/api/v1/public/atualizaPrefeitura/reprovarSolicitacao`
        let token_keycloack = sessionStorage.getItem('token_keycloack');
        const opcoes = {
			method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', "Authorization": `Bearer ${token_keycloack}` },
            body: 
            "sqSolicitacao="+ sqSolicitacao +
            "&usuarioLogado="+ getUsuarioLogado() +
            "&justificativa="+ justificativa
		};
        fetchWithToken(url, opcoes)
        .then(res => res.json())
        .then(res => {
            const retorno = JSON.parse(res);
            //const retornoTratado = JSON.parse(retorno[0]);
			if(retorno[0].status === 'OK'){
                setSolicitacoes(res);
                window.location.reload();
                setLoader(false)
                alert("Solicitação foi recusada!")
            }
            else {
                alert("Erro interno na aplicação - " + res.trace)
                console.error("Erro interno na aplicação - " + res.trace)
            }
            setLoader(false)
        })
        .catch(_err => {
            alert("Erro interno na aplicação - " + _err)
            console.error("Erro interno na aplicação - " + _err)
            setLoader(false)
        });
    }

    function visualizarArquivo (idSolicitacao, nomeArquivo) {

        setLoader(true)
        let url = `${URL_API}/api/v1/public/atualizaPrefeitura/visualizarArquivo/${idSolicitacao}`
        let token_keycloack = sessionStorage.getItem('token_keycloack');
        const opcoes = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', "Authorization": `Bearer ${token_keycloack}` },
		};
        fetchWithToken(url, opcoes)
        .then(res => {
            if (!res.ok) {
                setLoader(false)
                throw new Error('Erro ao baixar o arquivo');
            }
            return res.blob();
        })
        .then(blob => {
            const href = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');

            link.href = href;
            link.setAttribute('download', nomeArquivo)
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link)
            window.URL.revokeObjectURL(href);
            setLoader(false)
        })
        .catch(_err => {
            alert("Erro interno na aplicação - " + _err)
            console.error("Erro interno na aplicação - " + _err)
            setLoader(false)
        });
    }

    function carregarTabela(){
        $(document).ready(function () {
            setTimeout(function () {
                $('#tblDados').DataTable({
                    columnDefs: [
                        { orderable: true, targets: 2 },
                        { orderable: true, targets: 3 },
                        { orderable: true, targets: 4 }
                    ],
                    lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "Todos"]],
                    pageLength: 200,
                    columns: [{ width: '20%' }, null, { width: '5%' },  null, { width: '10%' }, { width: '5%' }, { width: '5%' }, { width: '5%' }, { width: '5%' }],
                    order: [[1, 'asc']],
                    language: {
                        url: '/pt-BR.json'
                    }
                });
            }, 100);
        });
    }


    return (
        <div>
            <header className="main">
                <h2>Solicitações Aguardando Aprovação</h2>
            </header>
            <div className="row">
				<div className="col-12">
				{(loader && <DistVafCircularProgress />)}
                    <div className="col-12 align-right">
                        <Button variant="contained" className="button-secondary" onClick={ () => window.location.reload()} style={{"margin": "0 15px"}}>
                            Atualizar Página
                        </Button> 
                        
                        <Button variant="contained" className="button-secondary" onClick={ () => nav(-1) }>Voltar</Button>
                    </div>
					<div className="margem-antes"></div>
                        <table id='tblDados'className="stripe row-border hover">
                            <thead>
                                <tr>
                                    <th>Prefeitura</th>
                                    <th>Responsável</th>
                                    <th>Telefone</th>
                                    <th>Email</th>
                                    <th>Identificação</th>
                                    <th>Data da Solicitação</th>
                                    <th>Documento</th>
                                    <th>Aprovar</th>
                                    <th>Recusar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {solicitacoes.map((solicitacao) => (
                                    <tr key={solicitacao.codigoPrefeitura}>
                                        <td>{solicitacao.nome}</td>
                                        <td>{solicitacao.responsavel}</td>
                                        <td>{solicitacao.telefone}</td>
                                        <td>{solicitacao.email}</td>
                                        <td>{formatarIdentificacao(solicitacao.identificacao)}</td>
                                        <td>{solicitacao.dtSolicitacaoStr}</td>
                                        <td> 
                                            <Button variant="contained" color="primary" onClick={() => visualizarArquivo(solicitacao.sqSolicitacao, solicitacao.nmComprovante)} startIcon={<PictureAsPdfOutlined />} style={{ width: '85%' }}>
                                                Visualizar
                                            </Button>    
                                        </td>
                                        <td>
                                            <Button variant="contained" color="success" onClick={() => aprovarSolicitacao(solicitacao.sqSolicitacao)} startIcon={<ApprovalOutlined/>} style={{ width: '85%' }}>
                                                Aprovar
                                            </Button> 
                                        </td>
                                        <td>
                                            <Button variant="contained" color="error" onClick={() => {setMostrarModalJustificativa(true); setSolicitacaoSelecionado(solicitacao.sqSolicitacao);}} startIcon={<CancelOutlined/>} style={{ width: '85%' }}>
                                                Recusar
                                            </Button> 
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {				
                            <Dialog open={mostrarModalJustificativa} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                                <DialogTitle id="alert-dialog-title"></DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                       Informe a justificativa da recusa para ser enviada ao solicitante:
                                    </DialogContentText>
                                        <TextField
                                            autoFocus
                                            id="justificativa"
                                            type="text"
                                            multiline
                                            fullWidth
                                            onChange={e => setJustificativa(e.target.value)}
                                            variant="standard"
                                            size='398'
                                            maxRows={5}
                                            maxlenght={398}
                                            onInput={(e) => e.target.value = e.target.value.slice(0, 399)}
                                        />
                                </DialogContent>
                                <DialogActions>
                                    <Button variant="contained" color="primary" onClick={() => reprovarSolicitacao(solicitacaoSelecionado, justificativa)}>Recusar e comunicar ao responsável</Button>    
                                    <Button variant="contained" color="primary" onClick={ () => setMostrarModalJustificativa(false)}>Cancelar</Button>
                                </DialogActions>
                            </Dialog> 
                        }
                    </div>
                </div>    
        </div>
    )
}